// Delegation also handles sections replaced by the theme editor.
document.addEventListener('pointerdown', (event) => {
  if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary) return;
  if (!(event.target instanceof Element)) return;
  if (event.target.closest('button, input, textarea, select, [contenteditable="true"]')) return;
  const track = event.target.closest('.eea__track');
  if (!(track instanceof HTMLElement) || track.scrollWidth <= track.clientWidth) return;

  const startX = event.clientX;
  const startScroll = track.scrollLeft;
  const pointerId = event.pointerId;
  const controller = new AbortController();
  const options = { signal: controller.signal };
  let dragging = false;

  const finish = () => {
    controller.abort();
    track.classList.remove('is-dragging');
    if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
    if (dragging) {
      // A drag over linked card text must not activate the link on release.
      const suppressClick = (/** @type {MouseEvent} */ click) => {
        click.preventDefault();
        click.stopImmediatePropagation();
      };
      track.addEventListener('click', suppressClick, { capture: true, once: true });
      setTimeout(() => track.removeEventListener('click', suppressClick, true), 0);
    }
  };

  window.addEventListener('pointermove', (move) => {
    if (move.pointerId !== pointerId) return;
    if (!(move.buttons & 1)) return finish();
    const delta = move.clientX - startX;
    if (!dragging && Math.abs(delta) < 5) return;
    if (!dragging) {
      dragging = true;
      track.classList.add('is-dragging');
      track.setPointerCapture(pointerId);
      window.getSelection()?.removeAllRanges();
    }
    move.preventDefault();
    track.scrollLeft = startScroll - delta;
  }, options);
  window.addEventListener('pointerup', (up) => {
    if (up.pointerId === pointerId) finish();
  }, options);
  window.addEventListener('pointercancel', (cancel) => {
    if (cancel.pointerId === pointerId) finish();
  }, options);
  track.addEventListener('lostpointercapture', finish, options);
  window.addEventListener('blur', finish, options);
  track.addEventListener('dragstart', (drag) => drag.preventDefault(), options);
});

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-eea-previous], [data-eea-next]');
  if (!button) return;

  const section = button.closest('.eea');
  const track = section?.querySelector('.eea__track');
  const card = track?.querySelector('.eea__card');
  if (!track || !card) return;

  const styles = getComputedStyle(track);
  const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
  const direction = button.hasAttribute('data-eea-previous') ? -1 : 1;

  track.scrollBy({
    left: direction * (card.getBoundingClientRect().width + gap),
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
  });
});
